import { combineReducers } from 'redux';
import {
  createSimpleToggleReducer,
  createToggleAndSetReducer,
} from '../../redux-util/general-helpers';
import * as act from './middle-actions';
import { withDestroyViewerReset } from '../../reset-reducer-helpers';

export default withDestroyViewerReset(
  combineReducers({
    isPanelOpen: createSimpleToggleReducer(act.togglePanel().type, false),
    isSearchOpen: createToggleAndSetReducer(
      act.toggleSearch().type,
      act.setSearch().type,
      false
    ),
    isReadAloudOpen: createToggleAndSetReducer(
      act.toggleReadAloud().type,
      act.setReadAloud().type,
      false
    ),
    notesFilterOn: createSimpleToggleReducer(
      act.toggleNotesFilter().type,
      true
    ),
    highlightsFilterOn: createSimpleToggleReducer(
      act.toggleHighlightsFilter().type,
      true
    ),
    bookmarksFilterOn: createSimpleToggleReducer(
      act.toggleBookmarksFilter().type,
      true
    ),
  })
);



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/middle/middle-reducer.js